"use strict";
exports.__esModule = true;
exports.xnavVersionData = {
    productType: 'xnav',
    versions: [
        {
            version: '1.0.0',
            apiVersion: '5.15.0',
            title: '',
            date: 'Jun 05, 2025',
            showDate: true,
            logs: [
                'Initial Release.'
            ]
        }
    ]
};
//# sourceMappingURL=xnav-version.js.map


// WEBPACK FOOTER //
// ./app/xnav-version.js